import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SystemRequirementsPage from './pages/SystemRequirementsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import OfferPage from './pages/OfferPage';
import CookieConsentBanner from './components/CookieConsentBanner';
import CookiesPage from './pages/CookiesPage';
import FAQPage from './pages/FAQPage';
import ContactsPage from './pages/ContactsPage';
import NotFoundPage from './pages/NotFoundPage';
import SecurityPage from './pages/SecurityPage';
import RefundPage from './pages/RefundPage';

export default function App() {
  return (
    <BrowserRouter>
      <CookieConsentBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/system-requirements" element={<SystemRequirementsPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

